// A failed save must never publish the previous artwork/settings as a success.
export default async function saveBeforePublish(save, publish) {
  if (await save() !== true) throw new Error("Save the design successfully before sharing it.");
  return publish();
}
